module.exports = __webpack_public_path__ + "img/phone.7803081d.png";